import type { BrandSlots } from "@cfg/brand-sdk";

/** Unstyled-but-decent fallbacks for slots a brand does not provide. */
export const DefaultHeader: BrandSlots["Header"] = ({ brand, nav, user, onSignIn, onSignOut }) => (
  <header className="df-header">
    <a href="/" className="df-brand">
      {brand.name}
    </a>
    <nav className="df-nav">
      {nav.map((n) => (
        <a key={n.href} href={n.href} className={n.active ? "is-active" : undefined}>
          {n.label}
        </a>
      ))}
      {user ? (
        <button type="button" className="cfg-btn" onClick={onSignOut}>
          Sign out
        </button>
      ) : (
        <button type="button" className="cfg-btn" onClick={onSignIn}>
          Sign in
        </button>
      )}
    </nav>
  </header>
);

export const DefaultFooter: BrandSlots["Footer"] = ({ brand, madeWith }) => (
  <footer className="df-footer">
    {brand.tagline || brand.name}
    {madeWith && <small className="df-footer-made">{madeWith}</small>}
    {brand.fitTags.disclaimer && <small className="df-footer-legal">{brand.fitTags.disclaimer}</small>}
  </footer>
);

export const DefaultCatalogCard: BrandSlots["CatalogCard"] = ({ entry, children }) => (
  <a className={`df-card${entry.kind === "community" ? " df-card-community" : ""}`} href={entry.href}>
    <div className="df-card-preview">{children ?? (entry.thumbnailUrl ? <img src={entry.thumbnailUrl} alt="" loading="lazy" /> : null)}</div>
    <h3>{entry.title}</h3>
    {entry.kind === "community" ? (
      <>
        {entry.fits && entry.fits.length > 0 && (
          <ul className="df-card-fits" aria-label={entry.fitLabel}>
            {entry.fits.slice(0, 3).map((f) => (
              <li key={f.ref} className="df-card-fit" title={f.name}>
                {f.ref}
                {f.name && <span className="df-card-fit-name"> {f.name}</span>}
              </li>
            ))}
          </ul>
        )}
        <p className="df-card-meta">{[entry.designTitle, entry.author].filter(Boolean).join(" · ")}</p>
      </>
    ) : (
      entry.description && <p>{entry.description}</p>
    )}
  </a>
);

export const DefaultEmptyState: BrandSlots["EmptyState"] = ({ title, body, action }) => (
  <div className="df-empty">
    <h2>{title}</h2>
    {body && <p>{body}</p>}
    {action}
  </div>
);

export const DefaultConfiguratorFrame: BrandSlots["ConfiguratorFrame"] = ({ children, aside }) => (
  <div className="df-frame">
    {children}
    {aside}
  </div>
);
